import { render, staticRenderFns } from "./TendersTable.vue?vue&type=template&id=9d6e6140&scoped=true&"
import script from "./TendersTable.vue?vue&type=script&lang=js&"
export * from "./TendersTable.vue?vue&type=script&lang=js&"
import style0 from "styles/dashboard/datatable.scss?vue&type=style&index=0&id=9d6e6140&scoped=true&lang=css&"
import style1 from "./TendersTable.vue?vue&type=style&index=1&id=9d6e6140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6e6140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d6e6140')) {
      api.createRecord('9d6e6140', component.options)
    } else {
      api.reload('9d6e6140', component.options)
    }
    module.hot.accept("./TendersTable.vue?vue&type=template&id=9d6e6140&scoped=true&", function () {
      api.rerender('9d6e6140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/TendersTable.vue"
export default component.exports